import { datadogRum } from '@datadog/browser-rum';
import { AxiosError } from 'axios';

import packageJson from '../../package.json';

interface DatadogUser {
  id: string;
  branchId: string;
  email: string;
  name: string;
  empNo: string;
  jobTitleCode: string;
  jobTitleName: string;
  productType: string;
  role: string;
}
const log = {
  initialize: () => {
    datadogRum.init({
      applicationId: import.meta.env.VITE_DATADOG_APP_ID ?? '',
      clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN ?? '',
      site: 'us5.datadoghq.com',
      service: 'spv-cockpit',
      env: import.meta.env.VITE_ENV,
      version: packageJson.version,
      sessionSampleRate: Number(
        import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE ?? 100,
      ),
      sessionReplaySampleRate: Number(
        import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE ?? 100,
      ),
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [
        url =>
          url?.startsWith(`${import.meta.env.VITE_API_BASEURL}/onboarding`) ||
          url?.startsWith(`${import.meta.env.VITE_API_BASEURL}/agency`),
      ],
    });

    datadogRum.startSessionReplayRecording();
  },
  sendError: (message: string, context: object) => {
    const error = new Error(message);
    const user = log.getDDUser();

    datadogRum.addError(error, { context, user });
  },
  sendAxiosError: (axiosError: AxiosError) => {
    log.sendError(axiosError.message, axiosError);
  },
  setDDUser: ({
    id,
    branchId,
    email,
    name,
    empNo,
    jobTitleCode,
    jobTitleName,
    productType,
    role,
  }: DatadogUser) => {
    datadogRum.setUser({
      id,
      branchId,
      email,
      name,
      empNo,
      jobTitleCode,
      jobTitleName,
      productType,
      role,
    });
  },
  updateDDUser: (user: DatadogUser) => {
    Object.entries(user).forEach(([key, value]) => {
      datadogRum.setUserProperty(key, value);
    });
  },
  getDDUser: () => datadogRum.getUser(),
  clearDDUser: () => {
    datadogRum.clearUser();
  },
};

export default log;
